<template>
  <template-info :bgImg="bgImg" title="เอกสารและขั้นตอน">
    <div>
      <div class="title">เอกสารประกอบการยื่นจดทะเบียนมีดังนี้</div>
      <div class="wrap-number-li">
        <span> 1. </span>
        <span class="contents"
          >แบบคำขอจดทะเบียน
          <span class="highlight" @click="goToDoc01()"
            >ภ.พ.01<img class="crll-img" :src="EXTERNALICON" alt="externalicon"
          /></span>
          และ
          <span class="highlight" @click="goToDoc01_1()"
            >ภ.พ.01.1<img
              class="crll-img"
              :src="EXTERNALICON"
              alt="externalicon"
          /></span>
          (กรณีใช้สิทธิ) จำนวน 3 ชุด
        </span>
      </div>
      <div class="wrap-number-li">
        <span> 2. </span>
        <span class="contents">หลักฐานที่ตั้งสถานประกอบการ </span>
      </div>
      <div class="wrap-number-li">
        <span> 3. </span>
        <span class="contents"
          >แผนที่พร้อมภาพถ่ายสถานประกอบการ ที่มีบ้านเลขที่
        </span>
      </div>
      <div class="wrap-number-li">
        <span> 4. </span>
        <span class="contents"
          ><span class="highlight" @click="goToDocPowerOfAttorney()"
            >หนังสือมอบอำนาจ<img
              class="crll-img"
              :src="EXTERNALICON"
              alt="externalicon" /></span
          >ปิดอากรแสตมป์ พร้อมสำเนาบัตรประชาชนของผู้มอบอำนาจ และผู้รับมอบอำนาจ
        </span>
      </div>
      <div class="wrap-number-li">
        <span> 5. </span>
        <span class="contents">สำเนาบัตรประชาชนและสำเนาทะเบียนบ้าน </span>
      </div>
      <div class="wrap-number-li">
        <span> 6. </span>
        <span class="contents"
          >สำเนา<span class="highlight" @click="goToDocCommercialRegistration()"
            >ใบทะเบียนพาณิชย์<img
              class="crll-img"
              :src="EXTERNALICON"
              alt="externalicon"
          /></span>
        </span>
      </div>
      <div class="wrap-number-li">
        <span> 7. </span>
        <span class="contents"
          >ภาพถ่ายหนังสือการจัดตั้งคณะบุคคลที่มิใช่นิติบุคคล
        </span>
      </div>
      <div class="wrap-number-li">
        <span> 8. </span>
        <span class="contents"
          >สำเนา<span class="highlight" @click="goToDocCertificate()"
            >หนังสือรับรองการจดทะเบียนหุ้นส่วนบริษัท<img
              class="crll-img"
              :src="EXTERNALICON"
              alt="externalicon"
          /></span>
          พร้อมวัตถุประสงค์
        </span>
      </div>
      <div class="wrap-number-li">
        <span> 9. </span>
        <span class="contents">หลักฐานแสดงฐานะนิติบุคคล </span>
      </div>
      <div class="wrap-number-li">
        <span> 10. </span>
        <span class="contents"
          >ภาพถ่ายหนังสือตั้งตัวแทนเป็นลายลักษณ์อักษร
        </span>
      </div>
      <div class="wrap-number-li">
        <span> 11. </span>
        <span class="contents"
          >ภาพถ่ายเอกสารการดำเนินกิจการร่วมค้า (ถ้ามี)
        </span>
      </div>
      <div class="wrap-number-li">
        <span> 12. </span>
        <span class="contents"
          >กรณีเป็นบุคคลต่างด้าว ต้องแนบเอกสารเพิ่ม ได้แก่
          ภาพถ่ายหนังสือเดินทางหรือเอกสาร ที่ใช้แทนหนังสือเดินทาง
          หรือภาพถ่ายใบสำคัญ ประจำตัวคนต่างด้าว
        </span>
      </div>
      <div class="wrap-knowledge">
        หลังจากยื่นเอกสารครบแล้ว สรรพากรจะออกเอกสาร
        <span class="bold">ใบทะเบียนภาษีมูลค่าเพิ่ม </span
        ><span class="highlight" @click="goToDoc20()"
          >แบบ ภ.พ. 20<img
            class="crll-img"
            :src="EXTERNALICON"
            alt="externalicon"
        /></span>
      </div>
      <div class="wrap-knowledge">
        มีผลให้เป็นผู้ประกอบการจดทะเบียนภาษีมูลค่าเพิ่ม
        ตามกฎหมายตั้งแต่วันที่ระบุไว้ในใบทะเบียนภาษี มูลค่าเพิ่มเป็นต้นไป
      </div>
    </div>
    <external-link
      @clickLink="readMoreInfo"
      caption="ดูข้อมูลเพิ่มเติม"
      class="link-desktop"
      style="margin-top: 30px;"
    />
  </template-info>
</template>

<script>
import BackgroundImg from "@/assets/images/infos/register_process.png";
import EXTERNALICON from "@/assets/icons/external.svg";

export default {
  name: "RegisterProcess",
  components: {},
  data() {
    const bgImg = BackgroundImg;
    return {
      bgImg: bgImg,
      EXTERNALICON,
    };
  },
  methods: {
    readMoreInfo() {
      window.open(
        "https://www.rd.go.th/publish/fileadmin/user_upload/SMEs/infographic/9.vat_360.pdf",
        "_blank"
      );
    },
  },
};
</script>

<style scoped>
.bold {
  font-weight: bold;
}
.wrap-knowledge {
  margin-top: 32px;
}
.crll-img {
  margin-left: 5px;
  height: 16px;
}
.wivb-contents {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-top: 23px;
  font-size: 17px;
  margin-bottom: 0px;
  color: #393d43;
}
.title {
  margin-bottom: 8px;
}
.wrap-number-li {
  display: flex;
  margin-bottom: 8px;
}
.wrap-number-li :first-child {
  min-width: 26px;
}
.highlight {
  color: #6db6f6;
  text-decoration: underline;
  cursor: pointer;
}
/*size  >768px */
@media only screen and (min-width: 769px) {
  .wrap-knowledge:last-child {
    margin-top: 0;
  }
}
</style>
